// extracted by mini-css-extract-plugin
module.exports = {"right":"right_style_right__16yZs"};